export default "__VITE_ASSET__BSNvbt57__"